// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__Dg1Da","avatarLg":"Avatar_avatarLg__yTyn3"};